import { ActionResult } from './Common';
import { SchoolListingChanges } from '../types';

export const PUBLISH_SCHOOL_LISTING_CHANGES = 'PUBLISH_SCHOOL_LISTING_CHANGES';
export type PUBLISH_SCHOOL_LISTING_CHANGES = typeof PUBLISH_SCHOOL_LISTING_CHANGES;

export interface PublishSchoolListingChanges {
    type: PUBLISH_SCHOOL_LISTING_CHANGES;
    value: {
        schoolId: string;
        changes: SchoolListingChanges;
    };
}

export type SchoolListingAction = PublishSchoolListingChanges | ActionResult;

export const publishSchoolListingChanges = (schoolId: string, changes: SchoolListingChanges) => {
    return {
        type: PUBLISH_SCHOOL_LISTING_CHANGES,
        value: {
            schoolId: schoolId,
            changes: changes
        }
    };
};